import { todayCalendarDate } from '../../../../components/calendar/monthGrid';
import { SALUTATIONS } from '../../../../lib/salutations';
import { uid } from '../../../../lib/uid';

/**
 * Autogenerate for the applicant form — every required field and the optional ones, so the
 * profile it produces exercises every row.
 *
 * **The name lands in `rsys_pii`, so it must not look like a person** — `Placeholder Testcase`, with
 * a tag so two clicks leave two rows somebody can tell apart. Contact values are synthetic too:
 * `example.test`, `+63 917 555`.
 */
export function sampleApplicant() {
  const tag = uid().slice(0, 6).toUpperCase();

  return {
    salutation: SALUTATIONS[Math.floor(Math.random() * SALUTATIONS.length)],
    firstName: 'Placeholder',
    middleName: 'Testcase',
    lastName: `Applicant ${tag}`,
    suffix: '',
    email: `applicant.${tag.toLowerCase()}@example.test`,
    mobileNumber: `+63 917 555 ${String(Math.floor(1000 + Math.random() * 9000))}`,
    dateApplied: todayCalendarDate(),
    remarks: 'Sample application for testing.',
  };
}
